
    const data = {"name":"sharp-arrow","data":{"width":"15","height":"15","viewBox":"5 5 15 15","data":"<path pid=\"0\" d=\"m9 12 6 6-3.25-6L15 6l-6 6Z\" _fill=\"#000\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}

            export default data
            